import { BrowserRouter, Routes, Route } from "react-router-dom";
import SignUp from "./screens/SignUp";
import SplashScreen from "./screens/SplashScreen";

import "./App.css";
import { useEffect, useLayoutEffect, useState } from "react";
import SignIn from "./screens/SignIn";
import Template from "./screens/Template";
import SettingScreen from "./screens/Settings/SettingScreen";
import Mystores from "./screens/stores/MyStores";
import Dashboard from "./screens/dashboard/Dashboard";
import EmployeeScreen from "./screens/employee/EmployeeScreen";
import StoreHome from "./screens/stores/StoreHome";
import WarehouseHome from "./screens/stores/warehouse/WarehouseHome";
import Customers from "./screens/customers/Customers";
import PayoutScreen from "./screens/payouts/PayoutScreen";
import SalesRecord from "./screens/salesRecord/SalesRecord";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import PuffLoader from "react-spinners/PuffLoader";
import PromptToSync from "./components/alerts/promptToSync";
import Receipt from "./screens/stores/makeTansaction/printTest/ReceiptGenerator";
import ReceiptPDF, { InvoiceGenerator } from "./screens/stores/makeTansaction/printTest/ReceiptPDFToEmail";
import VerifyEmail from "./screens/verifications/VerifyEmail";
import Customerrs from "./screens/customers/newInterface/Customers";
import WarehouseManagementPage from "./screens/stores/warehouse/newInterface/WarehouseHouseN";
import { uiAlert } from "./components/alerts/customAlert/uiAlert";
import CustomAlertModal from "./components/alerts/customAlert/CustomAlertModal";
window.alert = (msg) => uiAlert(msg, "info");

function App() {
  const [loading, setLoading] = useState(true);
  const [openPromptToSync, setOpenPromptToSync] = useState(false);
  const [mustSync, setMustSync] = useState(false);
  const { user } = useSelector((state) => state.webStoreUser);
  const { count, _ } = useSelector((state) => state.offlineQueue);

  useEffect(() => {
    updateViewPort();
    adjustFOntsizeOnInputs();

    if (document.readyState === "complete") {
      setLoading(false);
    } else {
      window.addEventListener("load", () => {
        setLoading(false);
      });
    }

    /* check if user state has been set in all routes expect login and signup otherwise reroute to login */

    if (window.location.pathname !== "/" && window.location.pathname !== "/sign-in" && window.location.pathname !== "/sign-up") {
      if (Object.keys(user)?.length === 0 || user === null || user === undefined) {
        console.log("user not found");
        window.location.href = "/sign-in";
      }
    }
    getAllInputs(); // to stop unwanted letters to be entered in input
    // disable console.log in production
    if (process.env.NODE_ENV === "production") {
      console.log = () => {};
    }

    window.addEventListener("resize", updateViewPort);

    return () => {
      window.removeEventListener("resize", updateViewPort);
    };
  }, []);

  const updateViewPort = () => {
    let viewport = window.innerHeight;
    document.documentElement.style.setProperty("--vh", `${viewport}px`);
    console.log(viewport);
    //alert("viewport height is " + viewport);
    // delete if not working
    /*   if (window.innerWidth < 668) {
      const designWidth = 800;
      const vh = window.innerHeight < 600 ? 600 : window.innerHeight; // minimum height of 600px
      const targetElement = document.querySelector(".templateWrapper > div:last-of-type");
      if (targetElement) {
        targetElement.style.height = `${vh - 70}px`;
      }
      console.log("viewport height", vh);

      const vw = window.innerWidth;
      // scale the 1024px layout down to the real device width
      const scale = vw / designWidth;
      const mv = document.querySelector('meta[name="viewport"]');
      if (mv) {
        mv.setAttribute("content", `width=${designWidth}, initial-scale=${scale.toFixed(3)}, maximum-scale=1, user-scalable=yes`);
      }
    } */
  };

  const adjustFOntsizeOnInputs = () => {
    //input, select, textarea, button

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    /* if (!isMobile) return; */

    let allInputs = document.querySelectorAll("input, select, textarea, button");
    allInputs.forEach((input) => {
      input.style.fontSize = "16px !important";
    });
  };
  /* check is event queue is up 500 and then sync automatically. */
  useEffect(() => {
    if (count > 100) {
      console.log("must sync");

      setMustSync(true);
      setOpenPromptToSync(true);
    }
  }, [count]);

  //stop unwanted letters to be inter in input

  const unWantedKey = ["e", "+", "-", "E"];

  const getAllInputs = () => {
    let allInputs = document.querySelectorAll("input");
    allInputs.forEach((input) => {
      input.addEventListener("keydown", (e) => {
        if (unWantedKey.includes(e.key)) {
          e.preventDefault();
        }
      });
    });
  };

  // disable console.log in production

  return (
    <>
      <CustomAlertModal />
      {!loading ? (
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<SplashScreen />} />

            <Route path='/sign-in' element={<SignIn />} />

            <Route path='/settings/:tab' element={<SettingScreen />} />
            <Route path='/mystores' element={<Mystores />} />
            <Route path='/dashboard' element={<Dashboard />} />
            {/* <Route path='/employees' element={<EmployeeScreen />} /> */}
            <Route path='/customers' element={<Customerrs />} />

            <Route path='/sales-record' element={<SalesRecord />} />
            <Route path='/generatReciept' element={<InvoiceGenerator />} />
            <Route path='/verifyEmail/:id' element={<VerifyEmail />} />

            <Route path='/mystores/:storeName/:storeID' element={<StoreHome setOpenPromptToSync={setOpenPromptToSync} />} />
            <Route path='/mystores/warehouse/:wareHouseID' element={<WarehouseManagementPage />} />
            <Route path='*' element={<h1>404</h1>} />
          </Routes>
        </BrowserRouter>
      ) : (
        <div style={style.loader}>
          <div style={style.container}>
            <PuffLoader color={"#0E49B5"} />
          </div>
        </div>
      )}
      {openPromptToSync && count && <PromptToSync closeModal={setOpenPromptToSync} must={mustSync} />}
    </>
  );
}

export default App;

const style = {
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    background: "white",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 1000,
    opacity: 0.8,
  },
  container: {
    width: "200px",
    height: "200px",
  },
};
